/* eslint-disable react/no-array-index-key */
import { useState, type FC, useEffect } from 'react';
import {
  Card,
  Table,
  TableHead,
  TableRow,
  Box,
  TableBody,
  TableCell,
  Button,
} from '@material-ui/core';
import { match } from 'ts-pattern';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';
// import { numberToMillons } from 'src/utils/functions';
import Loading from 'src/components/global/Loading';
import Minus from 'src/components/icons/Minus';
import Plus from 'src/components/icons/Plus';

interface ProspeccionContent {
  content: {
    data: any;
  };
  body: any,
  spinner,
  channel: string,
  onGet: any
}

const Prospeccion: FC<ProspeccionContent> = ({
  content, spinner, channel, body, onGet
}) => {
  const title = 'Prospección';
  const [open, setOpen] = useState(Object.fromEntries(
    Array.from({ length: content.data.length }, (_, i) => [i, false])
  ));
  const [spinner2, setSpinner2] = useState(Object.fromEntries(
    Array.from({ length: content.data.length }, (_, i) => [i, false])
  ));
  const [chanelData, setChanelData] = useState('canal');
  const [data, setData] = useState([]);

  useEffect(() => {
    setChanelData(channel);
    setOpen(Object.fromEntries(
      Array.from({ length: content.data.length }, (_, i) => [i, false])
    ));

    setData(content.data);
  }, [content.data]);

  const getDateString = (dateParam: Date): string => {
    const month = dateParam.getMonth() + 1;
    const day = dateParam.getDate();
    const monthString = month > 9 ? `${month}` : `0${month}`;
    const dayString = day > 9 ? `${day}` : `0${day}`;
    return `${dateParam.getFullYear()}-${monthString}-${dayString}`;
  };

  const getDetail = async (indice) => {
    if (!data[indice]?.detail) {
      setSpinner2((prevSpinner2) => ({
        ...prevSpinner2,
        [indice]: true,
      }));
      const res = await onGet({
        url: '/dashboard/ingresos-atencion/prospeccion/detail',
        body: {
          startDate: getDateString(body.startDate),
          endDate: getDateString(body.endDate),
          filter: content.data[indice].nombreComercial !== 'BBVA-Supervisor' ? content.data[indice].nombreComercial : null },
        global: false,
      });
      const resTotal = res.map((RowDetail) => ({
        ...RowDetail,
        total: Object.entries(RowDetail).filter(([clave]) => clave.endsWith('_numero') && !clave.endsWith('rechazado_numero')).map(([, valor]) => valor) // filtra los terminados en monto y devuelve el valor
          .map((numeroStr) => Number(numeroStr)) // transforma a numero
          .reduce((total, numero) => total + numero, 0), // suma todo el array
      }));
      setData((prevData) => prevData.map((element, index) => ({
        ...element,
        detail: index === indice ? resTotal : element.detail,
      })));
      setSpinner2((prevSpinner2) => ({
        ...prevSpinner2,
        [indice]: false,
      }));
    }
  };

  return (
    <Box mt={3}>
      <Title title={title} />
      <Card>
        <Scrollbar>
          <Table size="small" className="zoomin">
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic colSpan={4}>&nbsp;</TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={4}>
                  Aprobado
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={12}>
                  Rechazado
                  <br />
                  {/* {filter.startDate} */}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={1}>
                  Total Número
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                {
                  match(chanelData)
                    .with('jefeRelacion', () => <TableCellHeaderBasic colSpan={4}>Jefe de Relación</TableCellHeaderBasic>)
                    .with('jefeNegocio', () => <TableCellHeaderBasic colSpan={4}>Jefe de Negocio</TableCellHeaderBasic>)
                    .with('usuario', () => <TableCellHeaderBasic colSpan={4}>Usuario</TableCellHeaderBasic>)
                    .with('convenio', () => <TableCellHeaderBasic colSpan={4}>Convenio</TableCellHeaderBasic>)
                    .otherwise(() => <TableCellHeaderBasic colSpan={4}>Canal</TableCellHeaderBasic>)
                }
                <TableCellHeaderBasic align="center" colSpan={2}>
                  Número
                </TableCellHeaderBasic>
                {/* <TableCellHeaderBasic align="center" colSpan={2}>
                  Monto
                </TableCellHeaderBasic> */}
                <TableCellHeaderBasic align="center" colSpan={2}>
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={2}>
                  Buro
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={2}>
                  Calificación
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={2}>
                  Inelegible
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={2}>
                  Rimac
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={2}>
                  Lista negra
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={2}>
                  Otros
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={2}>
                  <br />
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic align="center" colSpan={8}>
                  <br />
                  {/* {filter.startDate} */}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  <br />
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                  spinner && (
                    <TableRow>
                      <TableCell colSpan={22}>
                        <Loading />
                      </TableCell>
                    </TableRow>
                  )
                }
              {!spinner && data.map((item, index) => (
                chanelData !== 'canal' ? (
                  <TableRow key={index}>
                    <TableCell colSpan={4}>
                      {item.nombreComercial}
                    </TableCell>
                    <TableCell align="center" colSpan={2}>
                      {item.aprobado_numero}
                    </TableCell>
                    {/* <TableCell align="center" colSpan={2}>
                {item.aprobado_monto}
              </TableCell> */}
                    <TableCell align="center" colSpan={2}>
                      {item.aprobado_porcentaje}
                &nbsp;%
                    </TableCell>

                    <TableCell align="center">
                      {item.rechazado_buro_numero}
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_buro_porcentaje}
                &nbsp;%
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_clasificacion_numero}
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_clasificacion_porcentaje}
                &nbsp;%
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_clientes_indeseados_numero}
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_clientes_indeseados_porcentaje}
                &nbsp;%
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_fraude_potencial_numero}
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_fraude_potencial_porcentaje}
                &nbsp;%
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_lista_negra_numero}
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_lista_negra_porcentaje}
                &nbsp;%
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_otros_numero}
                    </TableCell>
                    <TableCell align="center">
                      {item.rechazado_otros_porcentaje}
                &nbsp;%
                    </TableCell>
                    <TableCell align="center">
                      {item.total}
                    </TableCell>
                  </TableRow>
                )
                  : (
                    <>
                      <TableRow key={index}>
                        <TableCell colSpan={4}>
                          {item.nombreComercial !== 'TOTAL'
                            ? (
                              <Button onClick={() => { setOpen({ ...open, [index]: !open[index] }); getDetail(index); }} style={{ padding: '0px', minWidth: '0px' }}>
                                {!open[index] && (<Plus />)}
                                {open[index] && (<Minus />)}
                                {item.nombreComercial}
                              </Button>
                            )
                            : item.nombreComercial}
                        </TableCell>
                        <TableCell align="center" colSpan={2}>
                          {item.aprobado_numero}
                        </TableCell>
                        <TableCell align="center" colSpan={2}>
                          {item.aprobado_porcentaje}
                    &nbsp;%
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_buro_numero}
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_buro_porcentaje}
                    &nbsp;%
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_clasificacion_numero}
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_clasificacion_porcentaje}
                    &nbsp;%
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_clientes_indeseados_numero}
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_clientes_indeseados_porcentaje}
                    &nbsp;%
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_fraude_potencial_numero}
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_fraude_potencial_porcentaje}
                    &nbsp;%
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_lista_negra_numero}
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_lista_negra_porcentaje}
                    &nbsp;%
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_otros_numero}
                        </TableCell>
                        <TableCell align="center">
                          {item.rechazado_otros_porcentaje}
                    &nbsp;%
                        </TableCell>
                        <TableCell align="center">
                          {item.total}
                        </TableCell>
                      </TableRow>
                      {
        (open[index] || true)
        && (
          <TableRow key={`rowKey-child-${index}`}>
            <TableCell colSpan={21} style={{ margin: '0px', padding: '0px' }}>
              <Table size="small" style={{ background: '#e6e6e6' }}>
                {!spinner2[index] && open[index]
                  && item?.detail?.map((detail, index2) => (
                    <TableRow key={`row-detail-${index}-${index2}`}>
                      <TableCell colSpan={1} width={235}>
                        {detail.nombreComercial}

                      </TableCell>
                      <TableCell align="center" colSpan={2}>
                        {detail.aprobado_numero}
                      </TableCell>
                      <TableCell align="center" colSpan={2}>
                        {detail.aprobado_porcentaje}
                    &nbsp;%
                      </TableCell>

                      <TableCell align="center">
                        {detail.rechazado_buro_numero}
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_buro_porcentaje}
                    &nbsp;%
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_clasificacion_numero}
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_clasificacion_porcentaje}
                    &nbsp;%
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_clientes_indeseados_numero}
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_clientes_indeseados_porcentaje}
                    &nbsp;%
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_fraude_potencial_numero}
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_fraude_potencial_porcentaje}
                    &nbsp;%
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_lista_negra_numero}
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_lista_negra_porcentaje}
                    &nbsp;%
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_otros_numero}
                      </TableCell>
                      <TableCell align="center">
                        {detail.rechazado_otros_porcentaje}
                    &nbsp;%
                      </TableCell>
                      <TableCell align="center" width={85}>
                        {detail.total}
                      </TableCell>
                    </TableRow>
                  ))}
                {spinner2[index] && open[index] && (
                <TableRow>
                  <TableCell colSpan={22}>
                    <Loading />
                  </TableCell>
                </TableRow>
                )}
              </Table>
            </TableCell>
          </TableRow>
        )
      }
                    </>
                  )
              ))}
            </TableBody>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
};

export default Prospeccion;
